import { Service } from "../../types/services";

type ServiceCategory = {
    type: string | number;
    services: Service[]
}

type Keys = "type" | "name" | "description" | "status" | "id" | "statusCode";

export const groupServices: (services: Service[], keyToExtract?: Keys) => ServiceCategory[] = (services, keyToExtract = "type") => {
    let servicesArray: ServiceCategory[] = [];
    services.forEach(service => {
        if (!servicesArray.find(s => s.type === service[keyToExtract])) {
            servicesArray.push({
                type: service[keyToExtract],
                services: [{ ...service }]
            });
        } else {
            const index = servicesArray.findIndex(s => s.type === service[keyToExtract]);
            servicesArray[index].services.push({ ...service });
        }
    });

    return servicesArray;
}